<!-- 添加商品规格 -->
 <template>
 <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" 
        :before-close="handleClose" append-to-body>
    <el-form :model="ruleForm" :rules="rules" ref="formRef" label-width="100px">   
    <el-row>
        <el-col :span="12">
            <el-form-item label="规格名称" prop="specName">  
                <el-input v-model="ruleForm.specName" placeholder="请输入规格名称" ></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="副名称" prop="specSubName">  
                <el-input v-model="ruleForm.specSubName" placeholder="请输入规格副名称" ></el-input>
            </el-form-item>
        </el-col>
    </el-row>              
    <el-row>
        <el-col :span="12">
            <el-form-item label="商品价格" prop="productPrice">  
                <el-input v-model="ruleForm.productPrice" placeholder="请输入商品价格" >
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="销售模式" prop="productMode"> 
                <el-select v-model="ruleForm.productMode" style="width: 100%;">
                        <el-option 
                            v-for="item in typeOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
            </el-form-item>
        </el-col>
    </el-row>
    <el-row>
        <el-col :span="12">
            <el-form-item label="库存数量" prop="productQuality">  
                <el-input v-model="ruleForm.productQuality" placeholder="请输入商品数量" ></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="限购数量" prop="limitQuality">  
                <el-input v-model="ruleForm.limitQuality" placeholder="输入0不限购" ></el-input>
            </el-form-item>
        </el-col>
    </el-row>   
    <el-row>
        <el-col :span="12">
            <el-form-item label="规格详情" prop="des">
                <el-input v-model="ruleForm.des" placeholder="请输入规格详情" ></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否置顶" prop="isDefault">
                <el-radio-group v-model="ruleForm.isDefault">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-col>                
    </el-row>
    <el-row>
        <el-col :span="12">
            <el-form-item label="材质" prop="material">
                <el-input v-model="ruleForm.material" placeholder="请输入材质" ></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="尺寸" prop="size">
                <el-input  v-model="ruleForm.size"  placeholder="请输入尺寸"></el-input>
            </el-form-item>
           
        </el-col>            
    </el-row>
    <el-row>
        <el-col :span="12">
            <el-form-item label="重量" prop="weight">  
                <el-input v-model="ruleForm.weight" placeholder="请输入重量" ></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="颜色" prop="colour">  
                <el-input v-model="ruleForm.colour" placeholder="请输入颜色" ></el-input>
            </el-form-item>
        </el-col>
    </el-row>         
    <el-row>               
        <el-col>
            <el-form-item label="规格图片" prop="mainImageUrl" class="form" >
                <el-upload class="avatar-uploader" ref="coverPicUpload" action="" 
                    list-type="picture-card" accept="image/*" multiple :limit="9" name="file" 
                    :file-list="fileList" 
                    :on-change="handleFileChange" 
                    :http-request="handleRequest" 
                    :before-upload="handleBeforeUpload" 
                    :on-error="handleUploadError"
                    :on-remove="handleRemove">
                    <i class="el-icon-plus" />
                </el-upload>
            </el-form-item>   
        </el-col> 
    </el-row>
    <el-row>
        <el-col>
            <el-form-item label="详情图片" prop="detailImageUrl" class="form" >
                <el-upload class="avatar-uploader" ref="coverPicUpload2" action="" 
                        list-type="picture-card" accept="image/*"  multiple :limit="9" name="file"          
                        :file-list="fileList2" 
                        :on-change="handleFileChange2" 
                        :http-request="handleRequest2" 
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError"
                        :on-remove="handleRemove2">
                        <i class="el-icon-plus" />
                </el-upload>
            </el-form-item>   
        </el-col>      
    </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="confirmDialog">确定</el-button>
    </span>
</el-dialog>
 </div>
 </template>
 
 <script>
 export default {
    props:{       
        title:{
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default:{}
        },
    },
    components:{
        
    },
    data() {
        return {
            dialogTitle: '',            
            ruleForm: {
                specName: '',
                specSubName: '',
                productPrice: '',
                productQuality: 1,
                productMode: '',
                limitQuality: '',  
                material: '', 
                colour: '',
                weight: '',         
                size: '',   
                des: '',           
                isDefault: 0,
                mainImageUrl: '',
                detailImageUrl: '',             
            },
            rules: {
                specName:[
                    { required: true, message: '请输入规格名称', trigger: 'blur' },
                ],  
                specSubName :[
                    { required: false, message: '请输入规格副名称', trigger: 'blur' },
                ],  
                productPrice:[
                    { required: true, message: '请输入商品价格', trigger: 'blur' },
                ],  
                productQuality:[
                    { required: true, message: '请输入库存数量', trigger: 'blur' },
                ],                               
                productMode: [
                    { required: true, message: '请选择销售模式', trigger: 'change' },
                ],
                limitQuality: [
                    { required: true, message: '请选择输入限购数量', trigger: 'change' },
                ]              
            },
            disabled: false,
            editUsername: false,
            typeOption: [],
            deliverOption: [],
            refundOption: [],             
            dialogVisible: true, 
            productForm: {},
            fileList: [],   
            fileList2: [], 
            uploadedLinksMain: [],
            uploadedLinksText: [], 
        }
    },
    created() {      
        this.dialogTitle = this.title   
        this.productForm = {...this.formData}   
        if(this.dialogTitle === '更新规格'){
            this.ruleForm = {...this.formData}            
            if(this.ruleForm.mainImageUrl !== '' && this.ruleForm.mainImageUrl.indexOf(',') !== -1){
                let imageNames = this.ruleForm.mainImageUrl.split(',')
                
                const imageObjects = imageNames.map((name,index) =>{
                    return {
                        id: index,
                        name: name,
                        url: this.$global.uploadUrl+name
                    }
                })
                this.fileList = imageObjects
                this.uploadedLinksMain = imageObjects
            }else{
                if(this.ruleForm.mainImageUrl !== ''){
                    let imageObjects = [{
                        id: 0,
                        name: this.ruleForm.mainImageUrl,                        
                        url: this.$global.uploadUrl + this.ruleForm.mainImageUrl,
                    }]
                    this.fileList = imageObjects
                    this.uploadedLinksMain = imageObjects
                }
            }
            if(this.ruleForm.detailImageUrl !== ''  && this.ruleForm.detailImageUrl.indexOf(',') !== -1){
                let imageNames = this.ruleForm.detailImageUrl.split(',')
                
                const imageObjects = imageNames.map((name,index) =>{
                    return {
                        id: index,
                        name: name,
                        url: this.$global.uploadUrl+name
                    }
                })
                this.fileList2 = imageObjects
                this.uploadedLinksText = imageObjects
            }else{
                if(this.ruleForm.detailImageUrl !== ''){
                    let imageObjects = [{
                        id: 1,
                        name: this.ruleForm.detailImageUrl,                        
                        url: this.$global.uploadUrl + this.ruleForm.detailImageUrl,
                    }]
                    this.fileList2 = imageObjects
                    this.uploadedLinksText = imageObjects
                }
            }
        }  
    },
    mounted() {
        this.getType()
    },
    methods: {
        getType(){            
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 112,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })                   
                }
            })
        }, 
        confirmDialog() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 校验通过，传递表单数据到父组件
                    this.handleSubmit()    
                } else {
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    console.log('表单校验失败');
                    return false;
                }
            });
        }, 
        handleSubmit(){
            let { productPrice, productQuality, limitQuality, productMode, isDefault, specName,specSubName,
                des, material,size,weight,colour, mainImageUrl,detailImageUrl} = this.ruleForm            
         
            let { productId } = this.productForm
            let opcode = this.dialogTitle === '更新规格' ? this.$code.GoodsUpdateSpec : this.$code.GoodsAddSpec
            let params = {}
            let addParams = {
                opcode: opcode ,
                v_goods_serial: productId,
                v_goods_norms_title: specName,
                v_goods_norms_subtitle: specSubName,
                i_prices: productPrice,
                i_amount: productQuality,
                v_strategy: productMode,
                v_quota_set: limitQuality,
                v_Material: material,
                v_size: size,
                v_weight: weight,
                v_color: colour,
                c_topup: isDefault,  
                v_details: des, //商品规格详情 
                v_images: mainImageUrl, //商品规格图片                            
                v_details1: detailImageUrl,//规格详情图片                  
            }
            let updateParams = {
                i_norms_serial: this.productForm.productSpecId
                           
            }
            if(this.dialogTitle === '更新规格'){
                params =  Object.assign({}, addParams, updateParams)
            }else{
                params = addParams
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.disabled = true
                    if(this.dialogTitle==='更新规格'){
                        this.$message.success('更新规格成功')
                    }else{
                        this.$message.success('设置规格成功')
                    }    
                    this.closeDialog();
                    this.$emit('confirm');
                            
                }else{
                    this.$message.error(res.Message)
                }
            })
        },    
         // 文件选择变化时的回调
         handleFileChange(file, fileList) {
            // 手动校验文件数量
            if (fileList.length > 9) {
                this.$message.warning('最多只能上传9张图片');
                // 移除超出限制的文件（可选）
                fileList.pop(); // 保留最后选择的9个文件
                this.fileList = fileList.slice(0, 9);
                return;
            }
            this.fileList = fileList; // 更新文件列表         
        }, 
        async handleRequest(file, fileList){ 
            console.log(this.uploadedLinksMain)
            try{
                const imageUrl = await this.$help.uploadMoreFileRequest(file)

                if(imageUrl){
                    this.uploadedLinksMain.push(
                        {
                            name: imageUrl,
                            url: imageUrl
                        }
                    );
                }  
                this.$message.success('上传图片成功');
            }catch (error) {
                console.error('上传失败:', error);
                this.$message.error('上传失败，请重试');
            }
            // console.log('得到的url',this.uploadedLinksMain)
            this.ruleForm.mainImageUrl =  this.uploadedLinksMain.map(file => file.name).join(',')
        },
        // 文件选择变化时的回调
        handleFileChange2(file, fileList) {
            // 手动校验文件数量
            if (fileList.length > 9) {
                this.$message.warning('最多只能上传9张图片');
                // 移除超出限制的文件（可选）
                fileList.pop(); // 保留最后选择的9个文件
                this.fileList2 = fileList.slice(0, 9);
                return;
            }
            this.fileList2 = fileList; // 更新文件列表         
        }, 
        async handleRequest2(file,fileList){
            console.log(this.uploadedLinksText)
            try{
                const imageUrl = await this.$help.uploadMoreFileRequest(file)

                if(imageUrl){
                    this.uploadedLinksText.push(
                        {
                            name: imageUrl,
                            url: imageUrl
                        }
                    );
                }  
                this.$message.success('上传图片成功');
            }catch (error) {
                console.error('上传失败:', error);
                this.$message.error('上传失败，请重试');
            }
            // console.log('得到的url',this.uploadedLinksText)
            this.ruleForm.detailImageUrl =  this.uploadedLinksText.map(file => file.name).join(',')
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
            this.uploadedLinksMain =  fileList
            console.log(this.uploadedLinksMain)
            this.ruleForm.mainImageUrl =  this.uploadedLinksMain.map(file => file.name).join(',')
        },
        handleRemove2(file, fileList) {
            this.fileList2 = fileList;
            // 从已上传链接中移除对应的链接（如果存在）
            // const index = this.uploadedLinksText.findIndex(
            //     item => item.name === file.raw.name
            // );
            // if (index !== -1) {
            //     this.uploadedLinksText.splice(index, 1);
            // }
            this.uploadedLinksText =  fileList
            console.log(this.uploadedLinksText)
            this.ruleForm.detailImageUrl =  this.uploadedLinksText.map(file => file.name).join(',')
        },
        handleUploadError() {
            this.$message({
                type: "error",
                message: "上传失败",
            });
            this.loading.close();
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        }, 
        closeDialog() {
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        }
    }
 }
 </script>
 <style lang='scss' scoped>
 
 </style>


// WEBPACK FOOTER //
// src/views/product/components/addSpec.vue